<template>
    <div>
        <h2>Search the e-library</h2>
        <!-- In a default Laravel app, Vue will render inside an #app div -->
        <ais-instant-search
                :search-client="searchClient"
                :index-name="index"
        >
            <ais-search-box v-model="searchQuery" placeholder="Search matrices..."></ais-search-box>
            <img src="/images/algolia-blue-mark.png" class="ais-logo">

            <ais-hits v-show="searchQuery != ''" :transform-items="transformItems">
                <template slot="item" slot-scope="{ item }">
                    <div>
                        <p class="h6">{{ item.name }}</p>
                        <a class="btn btn-outline-dark btn-sm" target="_blank" :href="'/matrices/' + item.id + '/printView'"><i class="far fa-file-pdf"></i> view this matrix</a>
                    </div>
                </template>
            </ais-hits>
        </ais-instant-search>
    </div>
</template>

<script>
    import algoliasearch from 'algoliasearch/lite';
    import 'instantsearch.css/themes/satellite-min.css';

    export default {
        props: ['index'],
        data() {
            return {
                searchQuery: '',
                searchClient: algoliasearch(
                    process.env.MIX_ALGOLIA_APP_ID,
                    process.env.MIX_ALGOLIA_SEARCH_ONLY
                ),

                //index: process.env.MIX_ALGOLIA_INDEX
            }
        },

        methods: {
            viewMatrix: function (id) {
                const vm = this
                $.ajax({
                    url: '/matrices/' + id + '/printPDF',
                    contentType: 'application/json',
                    dataType: 'json',
                })
                    .fail()
                    .done(function (response) {
                        console.log(response)
                    })
            },

            transformItems(items) {
                return items.filter(item => item.public == 1)
            },
        },

    };
</script>

<style scoped>
  .ais-InstantSearch {
      position: relative;
  }

  .ais-logo {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 30px;
  }
</style>
